<ion-input
	[readonly]="true"
	(click)="onOpenSelect()"
	[ngClass]="{
		'error-class':
			form.get(dynamicFormControl.key).invalid &&
			(form.get(dynamicFormControl.key).dirty || form.get(dynamicFormControl.key).touched),
		'disabled-class': dynamicFormControl.disabled
	}"
	[ngModel]="selectedValue"
></ion-input>
<ng-container item-right
	><ion-icon [ngClass]="dynamicFormControl.disabled ? 'icon-Arrow-Down disabled-class' : 'icon-Arrow-Down'"></ion-icon
></ng-container>
